import { useEffect, useRef } from 'react';
import { custom } from 'devextreme/ui/dialog';
import {
  enableAllDiscussionNotificationChannels,
  hasAnyDiscussionNotificationChannelEnabled,
  readDiscussionNotificationPromptDismissed,
  writeDiscussionNotificationPromptDismissed
} from './discussionNotificationPrefs';
import { requestSystemNotificationPermission } from './discussionSystemNotification';

export interface DiscussionNotificationPromptProps {
  enabled: boolean;
}

export function DiscussionNotificationPrompt({ enabled }: DiscussionNotificationPromptProps) {
  const shownRef = useRef(false);

  useEffect(() => {
    if (!enabled || shownRef.current) return;
    if (readDiscussionNotificationPromptDismissed()) return;
    if (hasAnyDiscussionNotificationChannelEnabled()) return;

    shownRef.current = true;

    const dialog = custom({
      title: 'Discussion alerts',
      messageHtml:
        'Enable alerts when someone else comments on a file you have open? You can choose sound, in-app toast, and desktop notifications in Settings → Editors.',
      buttons: [
        {
          text: 'Enable all',
          type: 'default',
          onClick: () => {
            enableAllDiscussionNotificationChannels();
            void requestSystemNotificationPermission();
            writeDiscussionNotificationPromptDismissed(true);
            return true;
          }
        },
        {
          text: 'Not now',
          onClick: () => {
            writeDiscussionNotificationPromptDismissed(true);
            return true;
          }
        }
      ]
    });

    void dialog.show();
  }, [enabled]);

  return null;
}
